import { ProposalQualityScore } from './proposalQualityScore.models';

export interface ProposalQualityScoreState {
  entities: Record<string, ProposalQualityScore>;
  selectedAppointmentProposalId: string | null;
  loadedAppointmentProposalIds: string[];
  error: string | null;
  isLoaded: boolean;
  isLoading: boolean;
}

type Action =
  | {
      type: 'FETCH_PROPOSAL_QUALITY_SCORE';
      payload: { appointmentProposalId: string };
    }
  | {
      type: 'FETCH_PROPOSAL_QUALITY_SCORE_SUCCESS';
      payload: {
        appointmentProposalId: string;
        qualityScore: ProposalQualityScore;
      };
    }
  | {
      type: 'FETCH_PROPOSAL_QUALITY_SCORE_FAILURE';
      payload: { error: string };
    }
  | {
      type: 'SET_LOADING_STATE';
      payload: { isLoading: boolean; isLoaded: boolean };
    };

export const initState: ProposalQualityScoreState = {
  entities: {},
  selectedAppointmentProposalId: null,
  loadedAppointmentProposalIds: [],
  error: null,
  isLoaded: false,
  isLoading: false,
};

export const proposalQualityScoreReducer = (
  state: ProposalQualityScoreState,
  action: Action
): ProposalQualityScoreState => {
  switch (action.type) {
    case 'FETCH_PROPOSAL_QUALITY_SCORE':
      return {
        ...state,
        error: null,
        isLoading: true,
        isLoaded: state.loadedAppointmentProposalIds.includes(
          action.payload.appointmentProposalId
        ),
        selectedAppointmentProposalId: action.payload.appointmentProposalId,
      };
    case 'FETCH_PROPOSAL_QUALITY_SCORE_SUCCESS':
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        loadedAppointmentProposalIds: [
          ...new Set([
            ...state.loadedAppointmentProposalIds,
            action.payload.appointmentProposalId,
          ]),
        ],
        entities: {
          ...state.entities,
          [action.payload.appointmentProposalId]: action.payload.qualityScore,
        },
      };
    case 'FETCH_PROPOSAL_QUALITY_SCORE_FAILURE':
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload.error,
      };
    case 'SET_LOADING_STATE':
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
